module.exports = __webpack_public_path__ + "static/media/mastercard.a329c114.svg";